import { Component, OnInit, Input, Output, EventEmitter, SimpleChanges } from '@angular/core';
import { Router } from '@angular/router';
import { SelfLearnService } from 'projects/selflearnv2-ui/src/app/services/self-learn/self-learn.service';
import {
  ApexChart,
  ApexResponsive,
} from 'ng-apexcharts';
import { MatDialog } from '@angular/material/dialog';
import { UnlockChapterDialogComponent } from '../../../components/unlock-chapter-dialog/unlock-chapter-dialog.component';
import { ExerciseStartDialogComponent } from '../../../components/exercise-start-dialog/exercise-start-dialog.component';
import { ExerciseCompletionDialogComponent } from '../../../components/exercise-completion-dialog/exercise-completion-dialog.component';

export type DonutChartOptions1 = {
  series: any;
  chart: ApexChart;
  responsive: ApexResponsive[];
  labels: any;
  plotOptions: any;
  colors: any;
  legend: any;
  xaxis: any;
  yaxis: any;
  fill: any;
  dataLabels: any;
  tooltip: any;
  stroke: any;
  states: any;
  title: any;
};

@Component({
  selector: 'app-topic-card',
  templateUrl: './topic-card.component.html',
  styleUrls: ['./topic-card.component.css']
})
export class TopicCardComponent implements OnInit {

  @Input() cardSubject:string;
  @Input() topicData:any = [];
  @Input() rowIndex:number;
  @Input() expandRowIndex = -1;
  @Input() totalTopics:number;
  @Output() onExpandedRowIndex: EventEmitter<any> = new EventEmitter<any>();

  public donutchartOptions1: Partial<DonutChartOptions1>;
  donutColor:any;

  constructor(public router: Router, public selfLearnService: SelfLearnService, public dialog: MatDialog) { }

  ngOnInit(): void {
    setTimeout(() => {
      this.expandSelectedTopic();
    }, 1000);
    console.log(this.topicData);
    console.log(this.cardSubject);
    if (this.cardSubject == 'Physics'){
      this.donutColor = '#D3641F';
    }
    if (this.cardSubject == 'Chemistry'){
      this.donutColor = '#BE3F54';
    }
    if (this.cardSubject == 'Maths'){
      this.donutColor = '#136884';
    }
    if (this.cardSubject == 'Biology'){
      this.donutColor = '#578A43';
    }
    if (this.cardSubject == 'Zoology'){
      this.donutColor = '#663D29';
    }
    if (this.cardSubject == 'Botany'){
      this.donutColor = '#106446';
    }
    if (this.cardSubject == 'Science'){
      this.donutColor = '#7082D4';
    }
    if (this.cardSubject == 'EVS'){
      this.donutColor = '#64AA7D';
    }
    if (this.cardSubject == 'English'){
      this.donutColor = '#C67AEB';
    }
    if (this.cardSubject == 'Hindi'){
      this.donutColor = '#E5AE7C';
    }
    if (this.cardSubject == 'Computer Science'){
      this.donutColor = '#7BB4CA';
    }
    if (this.cardSubject == 'Social Studies'){
      this.donutColor = '#C16634';
    }
    if (this.cardSubject == 'Civics'){
      this.donutColor = '#F7875D';
    }
    if (this.cardSubject == 'Geography'){
      this.donutColor = '#BACC77';
    }
    if (this.cardSubject == 'History'){
      this.donutColor = '#AA8171';
    }
    if (this.cardSubject == 'Logical Reasoning'){
      this.donutColor = '#EB749D';
    }
    if (this.cardSubject == 'General Test'){
      this.donutColor = '#AA4995';
    }
    if (this.cardSubject == 'Statistics'){
      this.donutColor = '#0B2F69';
    }
    if (this.cardSubject == 'Accountancy'){
      this.donutColor = '#16888A';
    }
    if (this.cardSubject == 'Economics'){
      this.donutColor = '#327DD4';
    }
    if (this.cardSubject == 'Business Studies'){
      this.donutColor = '#6193D9';
    }
    if (this.cardSubject == 'Commerce'){
      this.donutColor = '#1EC686';
    }
    if (this.cardSubject == 'Vedic Maths'){
      this.donutColor = '#2584E7';
    }
    if (this.cardSubject == 'Vedic Mathematics'){
      this.donutColor = '#2584E7';
    }
    if (this.cardSubject == 'Problem Solving'){
      this.donutColor = '#AC9595';
    }
    if (this.cardSubject == 'Critical Thinking'){
      this.donutColor = '#60C3D0';
    }

    // donut chart
    this.donutchartOptions1 = {
      series: [this.topicData?.topicProgress],
      chart: {
        height: 100,
        width: 67,
        type: 'radialBar',
        background: 'transparent',
        //offsetX: -1,
        //offsetY: 1,
        offsetX: -1,
        offsetY: 5,
      },
      plotOptions: {
        radialBar: {
          inverseOrder: false,
          startAngle: -80,
          endAngle: 280,
          offsetX: 0, // Move chart sides
          offsetY: 0, // Move chart top, bottom
          hollow: {
            margin: 0,
            size: '70%',
            background: 'transparent',
            position: 'front'
          },
          track: {
            show: true,
            startAngle: undefined,
            endAngle: undefined,
            background: 'transparent',
            strokeWidth: '100%',
            opacity: 1,
            margin: 0,
          },
          dataLabels: {
            show: false,
            name: {
              show: false,
              fontSize: '14px',
              fontFamily: undefined,
              fontWeight: 600,
              color: '#3076B5',
              offsetY: 20
            },
            value: {
              show: true,
              fontSize: '12px',
              fontFamily: 'Montserrat, sans-serif',
              fontWeight: 700,
              color: '#1E2A36',
              offsetY: 5,
              formatter: function (val:any) {
                return val + '%';
              }
            }
          },
        },
      },
      labels: ["Total"],
      fill: {
        type: 'gradient',
        gradient: {
          shade: 'light',
          type: 'vertical',
          shadeIntensity: 0.1,
          gradientToColors: undefined,
          inverseColors: true,
          opacityFrom: 1,
          opacityTo: 0.5,
          stops: [40, 100]
        },
        colors: [this.donutColor]
      },
      stroke: {
        lineCap: 'round'
      },
    };
  }

  getTimeInMinutes(seconds:any){
    return (seconds/60).toFixed(0);
  }

  getVideoDuration(seconds:any) {
    return this.selfLearnService.secondsToTime(seconds);
  }

  ngOnChanges(changes: SimpleChanges) {
    if(changes){this.expandSelectedTopic()};
  }

  setExpandRowIndex(){
    localStorage.setItem('learnTabExpandIndex', this.rowIndex+'');
    this.onExpandedRowIndex.emit(this.rowIndex);
  }

  navigateToVideoPlaybackScreen(videoId:any){
    this.setExpandRowIndex();
    this.setLocalStorageForPlaybackScreen(videoId)
    this.router.navigateByUrl("selfLearn-V2/videoplayback");
  }

  expandSelectedTopic(){
    this.resetTopicCard();
    if(this.expandRowIndex != -1){
    var divToExpand = document.getElementById('topic_accro'+this.expandRowIndex);
    divToExpand?.classList.toggle('expand', true);
    }
    if(this.expandRowIndex > 0) {divToExpand.scrollIntoView({
      behavior: 'smooth',
      block: "nearest",
    });}

  }

  resetTopicCard(){
    for (let index = 0; index < this.totalTopics; index++) {
      var divToExpand = document.getElementById('topic_accro'+index);
      if(divToExpand){divToExpand.classList.toggle('expand', false);}
    }
  }

  setLocalStorageForPlaybackScreen(videoId:any){
    localStorage.setItem("selfLearnPreviousPage", 'chapter');
    localStorage.setItem("selfLearnSelectedTopicId", this.topicData.topicId)
    localStorage.setItem("selfLearnSelectedTopicName", this.topicData.topicName)
    localStorage.setItem('selfLearnSelectedVideoId', videoId)
    localStorage.setItem('selectedTopicName',this.topicData.topicName );
  }
  convertMinutestoHHmm(duration:any ){ 
    let sec = duration?.toString().replace(/\D/g,'');
    sec = Number(sec);
    var hour = Math.floor(sec / 3600);
    var minutes = Math.floor(sec % 3600 / 60);
    var seconds = Math.floor(sec % 3600 % 60);
    if(hour > 0){
      return hour +"h "+ minutes+"m";
    }
    else if(minutes >0 && seconds>0)
    {
      return minutes+"m "+ seconds+"s";
    }
    else if(hour <=0 && minutes<=0){
      return seconds+"s";
    }
    else if(hour <=0 && minutes > 0){
      return minutes+"m";

    }
    else{
      return hour +"h "+ minutes+"m";
    }
   
  }



  openExerciseStartDialog() {
    localStorage.setItem("selfLearnPreviousPage", 'chapter');
    localStorage.setItem("selfLearnSelectedTopicId", this.topicData.topicId)
    localStorage.setItem("selfLearnSelectedTopicName", this.topicData.topicName)
    localStorage.setItem('selectedTopicName',this.topicData.topicName );


    let dialogRef =  this.dialog.open(ExerciseStartDialogComponent, {
        width: '768px',
        panelClass: 'SLV2-excercise-progress-modal',
        data: {
        dialogSection: 1,
        }
    });
    dialogRef.afterClosed().subscribe(result => {
      if(result){
        ++this.rowIndex;
        ++this.expandRowIndex;
        this.expandSelectedTopic();
      }
    });
  }

}
